<template>
    <div>
        <TheHeader class="mob-header" />
        <BaseTitle :infor="infor" />
        <BaseListUlmoudle1
            class="industry-experience-list-ul"
            :list="serviceList"
        />
        <TheFooter class="mob-the-footer-other" />
    </div>
</template>
<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseListUlmoudle1 from '@/components/module/BaseListUlmoudle1'

    import '@/assets/less/module/module-industry-experience-list_industry-experience-list-ul.less'

    export default {
        name: 'MobIndustryExperience',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseListUlmoudle1
        },
        data: function(){
            return {}
        },
        computed: {
            infor: function(){
                let infor = this.json.infor;
                return infor;
            },
            serviceList: function(){
                let json = JSON.parse(JSON.stringify(this.json)); 
                let serviceList = json.serviceList;
                let arr = serviceList.content.list;
                for(let i=0, l=arr.length; i<l; i++){
                    arr[i].image = arr[i].mobImages;
                }
                return serviceList;
            }   
        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.title-box {
    padding-bottom: .32rem;
}

</style>